export const defaultDisplayValue = (option: unknown) => {
  if (
    typeof option === "object" &&
    option !== null &&
    "label" in option &&
    typeof option.label === "string"
  ) {
    return option.label;
  }
  return "";
};
